/**
* @summary - Component that Provides Hospital Inofrmation State Handling
* @author Yuvasri S
* @since 2024-07-04
*/
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  hospitalInformation: {
    hospitalcode: '',
    hospitalname: '',
    locationflag: '',
    hospitaltype: '',
    directorname: '',
    state: '',
    address: '',
    postcode: '',
    telephoneno: '',
    emailaddress: '',
    faxno: '',
    branchmanager: '',
    handphoneno: '',
    telephonenum: '',
    faxnum: '',
    hospitalGroupId: '',
    clsvorate: ''
  },
  facilityDetails: {
    fmshos1: '',
    fmshos2: '',
    fmslo1: '',
    fmslo2: '',
    bemshos1: '',
    bemshos2: '',
    bemslo1: '',
    bemslo2: '',
    femshos1: '',
    femshos2: '',
    femslo1: '',
    femslo2: '',
    speciality: '',
    facilitiesoutside: '',
    nonhospitalfacilities: ''
  },
  additionalInfo: {
    landarea: '',
    clsarea: '',
    bedstrength: '',
    groundmaint: '',
    llssoilfactor: '',
    llsringgitfactor: ''
  },
  mashospitaldetailsId: null, // Add this to store the saved data ID
  masfacilitydetailsId: null,
  masadditionalinfodetailsId: null,
  technicalInfo: {
    hospitalgroup: '',
    clsvorate: '',
    databasename: '',
    servername: '',
    companyname: '',
    region: ''
  }
};

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    updateHospitalInformation: (state, action) => {
      state.hospitalInformation = { ...state.hospitalInformation, ...action.payload };
    },
    updateFacilityDetails: (state, action) => {
      state.facilityDetails = { ...state.facilityDetails, ...action.payload };
    },
    updateAdditionalInfo: (state, action) => {
      state.additionalInfo = { ...state.additionalInfo, ...action.payload }
    },
    setMashospitaldetailsId: (state, action) => {

      state.mashospitaldetailsId = action.payload;
    },
    setMasfacilitydetailsId: (state, action) => {
      state.mashospitaldetailsId = action.payload;
    },
    setMasadditionalinfodetailsId: (state, action) => {
      state.mashospitaldetailsId = action.payload;
    },
    updateTechnicalInfo: (state, action) => {
      state.technicalInfo = { ...state.technicalInfo, ...action.payload }
    },
  },
});

export const { updateHospitalInformation, updateFacilityDetails, updateAdditionalInfo, setMashospitaldetailsId, setMasfacilitydetailsId, setMasadditionalinfodetailsId, updateTechnicalInfo } = formSlice.actions;

export default formSlice.reducer;
